module.exports = ".content-questions, .radio-label {\n  font-family: \"Helvetica Neue\",Helvetica,Arial,sans-serif\n}\n\n.contact > button,\n.contact > a{\n  margin-left: auto;\n  margin-right: auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n\n.contact > a {\n  width: 132px;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/contact/contact.component.css
// module id = ./src/app/components/contact/contact.component.css
// module chunks = main